import React from 'react';

import TrustpilotReviews from '../TrustpilotReviews';

import SimplifiedFooterBlock from './components/FooterSimplifiedBlock';

const TrustPilotIconFooter = () => (
  <SimplifiedFooterBlock>
    <TrustpilotReviews theme="minimal" isExternalLink hideScore />
  </SimplifiedFooterBlock>
);

export default TrustPilotIconFooter;
